import { render, staticRenderFns } from "./CollectionPerformanceByDay.vue?vue&type=template&id=3a351a4a&scoped=true&"
import script from "./CollectionPerformanceByDay.vue?vue&type=script&lang=js&"
export * from "./CollectionPerformanceByDay.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPerformanceByDay.vue?vue&type=style&index=0&id=3a351a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a351a4a",
  null
  
)

export default component.exports